import { render } from "./story.vue?vue&type=template&id=45e6c50e&scoped=true"
import script from "./story.vue?vue&type=script&lang=js"
export * from "./story.vue?vue&type=script&lang=js"

import "./story.vue?vue&type=style&index=0&id=45e6c50e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45e6c50e"

export default script